import { track } from "@/lib/track";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CallbackModal from "@/components/CallbackModal";
import { useUI } from "@/context/UIContext";
import { PhoneCall } from "lucide-react";

export default function Layout() {
  const { pathname } = useLocation();
  const { setCallbackOpen } = useUI();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-white">
      <Header />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <CallbackModal />

      <button
        onClick={() => { track("click_rappel"); setCallbackOpen(true); }}
        className="fixed bottom-6 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-lime text-ink shadow-xl shadow-ink/20 transition-transform duration-300 hover:scale-110 lg:hidden"
        data-testid="floating-callback-btn"
        aria-label="Être rappelé"
      >
        <PhoneCall size={20} />
      </button>
    </div>
  );
}
